var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconShippingInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.72316 9.80705C3.64397 10.5542 3 11.7832 3 13.0958V25C3 27.2091 4.79086 29 7 29L11 29V24C11 21.7909 12.7909 20 15 20H17C19.2091 20 21 21.7909 21 24V29L25 29C27.2091 29 29 27.2091 29 25V13.0958C29 11.7832 28.356 10.5542 27.2768 9.80705L18.2768 3.57628C16.9071 2.62797 15.0929 2.62797 13.7232 3.57628L4.72316 9.80705Z",
    fill: "#F5DADF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 13.0958C3 11.7832 3.64397 10.5542 4.72316 9.80704L13.7232 3.57627C15.0929 2.62796 16.9071 2.62797 18.2768 3.57627L27.2768 9.80704C28.356 10.5542 29 11.7832 29 13.0958V25C29 27.2091 27.2091 29 25 29H7C4.79086 29 3 27.2091 3 25V13.0958Z",
    stroke: "#2D2926",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 24V29H21V24C21 21.7909 19.2091 20 17 20H15C12.7909 20 11 21.7909 11 24Z",
    stroke: "#2D2926",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShippingInfo);
export default __webpack_public_path__ + "static/media/iconShippingInfo.00a4073fb45810ea6374300ba6f975a7.svg";
export { ForwardRef as ReactComponent };